export const MOVIE = "movie";
export const SERIES = "series";

/**
 * The API returns movies and series as separate arrays of the same shape.
 * Tag each so one card component can route to the right detail page.
 *
 * The key for films is `movies` on category payloads but `videos` on search
 * results, so both are accepted.
 */
export const mergeCatalog = (payload) => [
  ...(payload?.movies ?? payload?.videos ?? []).map((item) => ({
    ...item,
    type: MOVIE,
  })),
  ...(payload?.series ?? []).map((item) => ({ ...item, type: SERIES })),
];

export const detailPath = (item) =>
  item.type === SERIES ? `/series/${item.id}` : `/movies/${item.id}`;

/** Reaction endpoints spell series as "serie". */
export const reactionTarget = (item) =>
  item.type === SERIES ? "serie" : "movie";

/**
 * An actor's credits arrive as role rows wrapping the real item:
 * { video: {...} } or { serie: {...} }. Flatten them into plain cards.
 */
export const flattenCredits = (episodeActors) => [
  ...(episodeActors?.videos ?? [])
    .filter((row) => row.video)
    .map((row) => ({ ...row.video, type: MOVIE, role: row.role_display })),
  ...(episodeActors?.series ?? [])
    .filter((row) => row.serie)
    .map((row) => ({ ...row.serie, type: SERIES, role: row.role_display })),
];
